<template>
  <div class="updataPassword">
    <div class="head">修改密码</div>
    <el-form
      label-position="right"
      :rules="rules"
      label-width="140px"
      :model="contentObj"
      ref="form"
    >
      <el-form-item label="输入原密码" prop="oldPassWord">
        <el-input
          type="password"
          placeholder="请输入原始密码"
          v-model="contentObj.oldPassWord"
          maxlength="30"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="输入新密码" prop="newPassWord"
        ><el-input
          type="password"
        @input="ProgressColor"
          placeholder="请输入新密码"
          v-model="contentObj.newPassWord"
        ></el-input
      ></el-form-item>
     <el-form-item v-if="contentObj.newPassWord.length>0">
      <el-progress :show-text="false" :stroke-width="26" :percentage="passwordStrength.percentage" :color="passwordStrength.color" ></el-progress>
      <p class="passwordStrengthText" :style="{color:passwordStrength.color}">{{passwordStrength.text}}</p>
     </el-form-item>
      <el-form-item label="请再次输入新密码" prop="newPassWord2"
        ><el-input
          type="password"
          placeholder="请再次输入新密码"
          v-model="contentObj.newPassWord2"
        ></el-input
      ></el-form-item>

      <el-form-item>
        <div class="btnList">
          <button class="sucess" @click.prevent="handleSubmit">确认</button>
          <button class="del">取消</button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { SetPassWord } from "@/api/user.js";
import { Message } from "element-ui";
export default {
  data() {
    return {
      contentObj: {
        oldPassWord: "",
        newPassWord: "",
        newPassWord2: "",
      },
      passwordStrength: {
        percentage: 0,
        color: '',
        text: ''
      },
      rules: {
        oldPassWord: [
          { required: true, message: "请输入原始密码", trigger: "blur" },
        ],
        newPassWord: [
          { required: true, message: "请输入新密码", trigger: "blur" },
        ],
        newPassWord2: [
          { required: true, message: "请再次输入新密码", trigger: "blur" },
          { validator: this.validatePassWord, trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    ProgressColor(){
      const password = this.contentObj.newPassWord;
      let strength = 0;

      if (password.length >= 8) strength += 25;
      if (/[a-z]/.test(password)) strength += 25;
      if (/[A-Z]/.test(password)) strength += 25;
      if (/[0-9]/.test(password)) strength += 25;

   this.passwordStrength.percentage=strength

      if (strength <= 25) {
        this.passwordStrength.color = "#F56C6C";
        this.passwordStrength.text = "弱";
      } else if (strength <= 50) {
        this.passwordStrength.color = "#E6A23C";
        this.passwordStrength.text = "中";
      } else if (strength <= 75) {
        this.passwordStrength.color = "#409EFF";
        this.passwordStrength.text = "强";
      } else {
        this.passwordStrength.color = "#67C23A";
        this.passwordStrength.text = "很强";
      }
    },

    validatePassWord(rule, value, callback) {
      if (value !== this.contentObj.newPassWord) {
        callback(new Error("两次输入的密码不一致"));
      } else {
        callback();
      }
    },
    async handleSubmit(e) {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          console.log("ok");
          const res = await SetPassWord({
            old_password: this.contentObj.oldPassWord,
            new_password: this.contentObj.newPassWord2,
          });
          console.log(res);
          Message({
            message: '修改成功',
            type: 'success'
          })
          this.contentObj.oldPassWord=''
          this.contentObj.newPassWord=''
          this.contentObj.newPassWord2=''
        } else {
          console.log("false");
        }
      });
    },
  },
};
</script>

<style scoped>
.passwordStrengthText{
  font-size: 12px;
  color: #999;
  margin-top: 5px;
}
::v-deep .el-progress-bar__outer{
  height: 5px !important;
}
.sucess {
  background-color: #0d53ff;
  color: white;
}
.del {
  background-color: #fff;
  color: #666666;
}
.btnList button {
  width: 80px;
  height: 32px;
  border: 1px solid #e9e9e9;
  margin-right: 20px;
  font-size: 14px;
  border-radius: 4px;
}
::v-deep .el-input {
  width: 570px;
  height: 36px;
}
::v-deep .el-progress {
  width: 570px;
}
::v-deep .el-textarea textarea {
  width: 570px;
  height: 100px;
}
::v-deep .el-textarea {
  width: 570px;
  height: 100px;
}
.head {
  font-size: 24px;
  font-family: Medium;
  margin-bottom: 27px;
}
.updataPassword {
  margin-top: 24px;
  margin-left: 24px;
  font-family: Regular;
}
</style>
